import Modal from 'src/components/Modal'
import ErrorLog from 'src/components/ErrorLog/ErrorLog'
import { Typography } from '@mui/material'
import { CheckinGenerateRestockListError } from '../../RestockingTypes'
import { useDispatch } from 'react-redux'
import { actions } from '../../RestockingState'
import { useSelector } from 'src/utils/store'
import { useHistory } from 'react-router-dom'
import * as S from './StartExecutionModalCheckinList.styles'

interface StartExecutionModalCheckinListProps {
  show: boolean
  title: string
  errors: CheckinGenerateRestockListError[]
  errorMode: boolean
  errorFn: () => void
  onError: () => void
  onClose: () => void
}

const StartExecutionModalCheckinList: React.FC<StartExecutionModalCheckinListProps> = ({
  show,
  title,
  errors,
  errorMode,
  errorFn,
  onError,
  onClose,
}) => {
  const { currentIdList, user } = useSelector((state) => state.restocking)
  const dispatch = useDispatch()
  const history = useHistory()

  const onSubmitStartCheckinRestockList = () => {
    if (!currentIdList) return

    dispatch(actions.startRestockingListPage({
      idList: currentIdList,
      badge: user?.badge,
      history,
      onError,
    }))
  }

  const rows = errors.map((error) => ({
    ...error,
  }))

  const renderErrorLog = () => {
    if (errors.length > 0) {
      return (
        <ErrorLog
          label='log de erros'
          columns={[
            { id: 'orderCode', label: 'Cód. do pedido' },
            { id: 'message', label: 'Mensagem de erro' },
          ]}
          rows={rows}
          enablePagination={false}
          width='100%'
          height='30vh'
        />
      )
    }
    return null
  }

  return (
    <>
      <Modal
        show={show}
        testId='start-execution-modal-checkin-list-test-id'
        centered
        title={title}
        closedButton={errorMode}
        closeButtonAction={onClose}
        body={(
          <S.Container>
            {renderErrorLog()}
            {
              errorMode ? (
                <>
                  <Typography>Ao clicar no botão abaixo, os pedidos com erro serão removidos.</Typography>
                  <S.CustomButton
                    title='Remover pedidos com erro'
                    bgColor='red'
                    hoverColor='redHover'
                    letterColor='white'
                    data-testid='error-fn-button-test-id'
                    onClick={errorFn}
                  />
                </>
              ) : (
                <>
                  <Typography>Ao clicar no botão abaixo, será direcionado para a tela de reposição.</Typography>
                  <S.CustomButton
                    title='Iniciar reposição'
                    bgColor='confirm'
                    hoverColor='confirmHover'
                    letterColor='white'
                    data-testid='start-restocking-test-id'
                    onClick={onSubmitStartCheckinRestockList}
                  />
                </>
              )
            }
          </S.Container>
        )}
      />
    </>

  )
}

export default StartExecutionModalCheckinList
